import moment from 'moment';
import { head } from 'lodash';

class ActivityRowController {
    constructor(startTimeService, basket, addGuestService, guestModalService, loadingService) {
        this.startTimeService = startTimeService;
        this.basket = basket;
        this.addGuestService = addGuestService;
        this.guestModalService = guestModalService;
        this.loadingService = loadingService;
    }

    $onInit () {
        this.loading = true;
    }

    isLoading () {
        if (this.loadingService.isLoading('availability')) {
            this.startTimes = undefined;
            return true;
        }
        this.getStartTimes();

        return this.loading;
    }

    getStartTimes () {
        if (!this.loadingService.isLoading('availability')) {
            if (this.event.available) {
                if (this.startTimes === undefined) {
                    this.updateIsotope();

                    this.loading = true;
                    this.startTimes = [];
                    this.event.type = 'activity';

                    return this.startTimeService.getStartTimes(this.event)
                        .then(response => {
                            const firstTime = head(response);
                            if (firstTime && firstTime.end.search(this.event.date) === -1) {
                                this.startTimes = undefined;
                                this.getStartTimes();
                                return;
                            }

                            this.startTimes = this.filterTimes(response);
                            this.loading = false;

                            this.updateIsotope();
                        });
                }

                return this.startTimes;
            }

            this.loading = false;
        }

        return [];
    }

    displayTime (time) {
        return this.startTimeService.displayTime(time);
    }

    displayDuration (time) {
        if (time.end) {
            return `${moment(`${time.end.replace('T', ' ')}+00:00`).diff(`${this.event.date} ${time.time}+00:00`, 'minutes')} minutes`;
        }

        return '';
    }

    displayQuantity (quantity) {
        let string = `${quantity} space`;
        if (quantity !== 1) {
            string += 's';
        }

        return string;
    }

    filterTimes (startTimes) {
        if (startTimes) {
            startTimes = startTimes.filter(time => {
                if (!time.quantity || time.quantity <= 0) {
                    return false;
                }

                return true;
            });
        }

        return startTimes;
    }

    noStartTimes () {
        if (!this.isLoading()) {
            return !!(this.startTimes && this.startTimes.length === 0);
        }

        return false;
    }

    toggleDisplayGuests (time) {
        this.addGuestService.setState({
            gender: time.gender,
            maximumGuests: time.quantity
        });

        if (time.gender) {
            let guests = this.addGuestService.getGuests();
            guests.forEach(guest => {
                if (!guest.id) {
                    guest.gender = time.gender;
                }
            });
            this.addGuestService.setState(guests, 'guests');
        }

        this.addGuestService.buildTitlesList();
        this.addGuestService.filterExistingGuests();

        this.guestModalService.setConfig({
            event: this.event,
            maximumGuests: time.quantity,
            gender: time.gender,
            time: time
        });

        this.guestModalService.show();
    }
}

ActivityRowController.$inject = ['startTimeService', 'basket', 'addGuestService', 'guestModalService', 'loadingService'];

export default ActivityRowController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/controllers/activity.row.controller.js